export class StatusConstants {
    public static Reopen = 'Reopen';
    public static Enrollment = 'Enrollment';
    public static Personal = 'Personal';
    public static Retail = 'Retail';

    public static Distributor = 'Distributor';
    public static GUEST = 'Guest';
    public static FPC = 'FPC';

    public static Novus = 'Novus';
    public static FBO = 'FBO';
    public static Assistant_Supervisor = 'Assistant Supervisor';
    public static Supervisor = 'Supervisor';
    public static Assistant_Manager = 'Assistant Manager';
    public static Manager = 'Manager';
    public static Unrecognized_Manager = 'Unrecognized Manager';
    public static Recognized_Manager = 'Recognized Manager';
    public static Senior_Manager = 'Senior Manager';
    public static Soaring_Manager = 'Soaring Manager';
    public static Sapphire_Manager = 'Sapphire Manager';
    public static Diamond_Sapphire_Manager = 'Diamond Sapphire Manager';
    public static Diamond_Manager = 'Diamond Manager';
    public static Double_Diamond_Manager = 'Double Diamond Manager';
    public static Triple_Diamond_Manager = 'Triple Diamond Manager';
    public static Diamond_Centurion_Manager = 'Diamond Centurion Manager';
    public static PreferredCustomer = 'Preferred Customer';

    public static SUCCESS = 'SUCCESS';
    public static FAILED = 'FAILED';
    public static IN_PROGRESS = 'IN_PROGRESS';
    public static QUEUED = 'QUEUED';
    public static COMPLETED = 'COMPLETED';

    public static ACTIVE = 'Active';

    public static MONTHLY_CC_EXCEEDED = 'Monthly CC Limit Exceeded';

    public static Preferred_Customer = 'Preferred Customer';
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/status.constants.ts